<div class="container">
  <div class="selector">
    {{emergencyTemplate}}
    @if (emergencyTemplate) {
      <volume-display-mode-selector></volume-display-mode-selector>
    }
  </div>

  @if (selectedVolumeColorMode==volumeColorMode.COLOR_MODE_VOLUME_MOVED) {
    <div class="threshold-form">
      <volume-threshold-form></volume-threshold-form>
    </div>
  }

  <canvas #canvas></canvas>

  @if (labelMin) {
    <div class="info">
      <div>{{labelMin}}</div>
      <div>{{labelMax}}</div>
    </div>
  }
</div>
